import { createBrowserRouter } from 'react-router-dom';
import { Shell } from './Shell';
import { BoardRoute } from './routes/BoardRoute';
import { DeskRoute } from './desk/DeskRoute';
import { ThoughtsRoute } from './thoughts/ThoughtsRoute';
import { FoldersRoute } from './folders/FoldersRoute';
import { WorkspacesRoute } from './workspaces/WorkspacesRoute';
import { ConnectRoute } from './routes/ConnectRoute';
import { ArcRoute } from './routes/ArcRoute';
import { PlaneRoute } from './routes/PlaneRoute';
import { FileRoute } from './routes/FileRoute';
import { OpenRoute } from './routes/OpenRoute';
import { WriteRoute } from './routes/WriteRoute';
import { NotFoundRoute } from './routes/NotFoundRoute';

export const router = createBrowserRouter([
  {
    element: <Shell />,
    children: [
      { path: '/', element: <DeskRoute /> },
      { path: '/plan', element: <BoardRoute /> },
      { path: '/thoughts', element: <ThoughtsRoute /> },
      // Opening a folder makes it the root, so the folder IS the route —
      // held in component state it would be lost on every re-read, the way
      // the arc's mode was.
      { path: '/folders', element: <FoldersRoute /> },
      { path: '/folders/:folderId', element: <FoldersRoute /> },
      { path: '/nooks', element: <WorkspacesRoute /> },
      // The page's earlier addresses, kept so a link already saved still lands.
      { path: '/spaces', element: <WorkspacesRoute /> },
      { path: '/workspaces', element: <WorkspacesRoute /> },
      { path: '/connect', element: <ConnectRoute /> },
      { path: '/arc/:arcId', element: <ArcRoute /> },
      // A mode is a place, not a toggle. Held in component state it was lost
      // every time the plan re-read and the route fell to its placeholder —
      // which is every drop — so the page silently returned to the log.
      { path: '/arc/:arcId/lanes', element: <ArcRoute mode="lanes" /> },
      { path: '/arc/:arcId/plane', element: <PlaneRoute /> },
      { path: '/write', element: <WriteRoute /> },
      { path: '/write/*', element: <WriteRoute /> },
      { path: '/file/*', element: <FileRoute /> },
      // One shape, kind resolved on arrival. `/thought/:id` is the form the app
      // has been emitting and is documented as canonical, so it stays as an
      // alias onto the same resolution rather than becoming a second mechanism.
      { path: '/o/:openId', element: <OpenRoute /> },
      { path: '/thought/:openId', element: <OpenRoute /> },
      { path: '*', element: <NotFoundRoute /> },
    ],
  },
]);
